/**
 * The guest transfer page's URL shape, exactly as the PHP apex router has it
 * (hub-php _root/index.php:2 + :58-63):
 *
 *   $path = trim(parse_url($_SERVER['REQUEST_URI'], PHP_URL_PATH), '/');
 *   preg_match('#^(cs/)?(\d{4,})$#', $path, $m)  →  ref = $m[2]
 *
 * so at-mysg.com/6929716, /cs/6929716 and /6929716/ are the same page, and
 * /cs/ changes nothing but the URL. React Router has no regex routes, and a
 * dynamic `/:ref` would outrank the catch-all for EVERY one-segment path
 * (`/dashbord` would stop reaching the Shell's NotFound), so App.tsx asks this
 * function first and only hands over paths it claims.
 *
 * `[0-9]`, not `\d`: PHP's \d (no /u flag) is ASCII-only.
 */
const TRANSFER_REF_PATH = /^\/+(?:cs\/)?([0-9]{4,})\/*$/;

export function matchTransferRefPath(pathname: string): string | null {
  const m = TRANSFER_REF_PATH.exec(pathname);
  return m ? (m[1] ?? null) : null;
}

/** A ref the page (and the API) accepts: the router's `\d{4,}`. */
export function isTransferRef(token: string): boolean {
  return /^[0-9]{4,}$/.test(token);
}
